import type { RouteLocationRaw } from 'vue-router';

import router from '@/routers';

/**
 * 同一オリジンの相対・絶対 URL を Vue Router の `to` に変換する。
 */
export function hrefToRouteLocation(href: string): RouteLocationRaw {
  const resolved = router.resolve(href);
  return {
    path: resolved.path,
    ...(Object.keys(resolved.query).length > 0 && { query: resolved.query }),
    ...(resolved.hash && { hash: resolved.hash }),
  };
}

/**
 * `routes.ts` で定義された SPA 画面かどうか。
 * 未定義パスは catch-all の `not_found` にマッチするため、フルページ遷移用 `<a>` に回す。
 */
export function isSpaInternalHref(href: string): boolean {
  if (!href || href.startsWith('#')) return false;
  if (/^javascript:/i.test(href)) return false;

  try {
    if (/^https?:\/\//i.test(href)) {
      const u = new URL(href);
      if (u.origin !== window.location.origin) return false;
    }
    const resolved = router.resolve(href);
    return resolved.name !== 'not_found';
  } catch {
    return false;
  }
}

/**
 * メイン SPA（`#app` + RouterView）がマウントされているページか。
 * Slim 等の非 SPA レイアウトでは `#app` が無いため、RouterLink では画面が切り替わらない。
 */
export function isClientSideSpaShellPresent(): boolean {
  if (typeof document === 'undefined') return false;
  return !!document.getElementById('app');
}

/**
 * RouterLink でクライアント遷移してよいか（SPA ルートかつ `#app` があるときのみ true）。
 */
export function shouldUseRouterLinkForHref(href: string): boolean {
  return isSpaInternalHref(href) && isClientSideSpaShellPresent();
}
